import DOMPurify from "dompurify"

export const sanitize = (value: string): string => {
  return DOMPurify.sanitize(value)
}
